export default function LineDiv() {
  return <div className="min-w-[6px] h-full bg-[#717db0]" />
}
